import { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Icons } from "../../assets/Svgs";

import {
    Box,
    Typography,
    TextField,
    Button,
    IconButton,
    CircularProgress,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import colors from "../../styles/colors";
import { useSignInMutation } from "../../store/services/userService";
import { setSession } from "../../utils/session";


const Login = () => {
    const navigate = useNavigate();
    const [showPass, setShowPass] = useState(false);
    const [signIn, { isLoading }] = useSignInMutation(); // API hook
    const [state, setState] = useState({
        email: "",
        password: "",
    });


    const handleInputs = (e) => {
        setState({ ...state, [e.target.name]: e.target.value });
    };

    const handleLogin = async (e) => {

        if (!state.email || !state.password) {
            toast.error("Please fill in all fields.");
            return;
        }

        try {
            const response = await signIn({ email: state.email, password: state.password }).unwrap();
            if (response.status === "1") {
                toast.success("Login successful!");
                setSession({
                    token: response.token,
                    user: response.user,
                });
                navigate("/dashboard/home"); // Redirect to dashboard
            } else {
                toast.error("Invalid email or password.");
            }
        } catch (error) {
            console.error("Sign-in error:", error);
            toast.error(error.data?.error ?? "Something went wrong. Please try again.");
        }
    };


    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 3,
                background: "linear-gradient(135deg, #F7B500, #D2D2D2)",
            }}
        >
            <Box
                display="flex"
                flexDirection={{ xs: "column-reverse", md: "row" }}
                justifyContent="center"
                alignItems="center"
                gap={3}
                width="100%"
                maxWidth={1200}
            >
                {/* Login Form */}
                <Box
                    sx={{
                        backgroundColor: "#fff",
                        p: { xs: 3, sm: 5 },
                        borderRadius: 3,
                        boxShadow: 3,
                        width: { xs: "100%", sm: 380 },
                        transition: "transform 0.3s ease-in-out",
                        "&:hover": { transform: "scale(1.05)" },
                    }}
                >
                    <Box textAlign="center">
                        <Icons.logoIcon width={182} height={130} />
                    </Box>

                    <Box mt={8}>
                        <Typography
                            variant="body1"
                            fontWeight="600"
                            color="text.secondary"
                            sx={{ fontFamily: "PRe", letterSpacing: 1 }}
                        >
                            Email
                        </Typography>
                        <TextField
                            fullWidth
                            name="email"
                            variant="outlined"
                            margin="normal"
                            value={state.email}
                            onChange={handleInputs}
                            placeholder="Your email"
                        />
                    </Box>

                    <Box mt={2}>
                        <Typography
                            variant="body1"
                            fontWeight="600"
                            color="text.secondary"
                            sx={{ fontFamily: "PRe", letterSpacing: 1 }}
                        >
                            Password
                        </Typography>
                        <Box
                            display="flex"
                            alignItems="center"
                            gap={1}
                            sx={{
                                border: "1px solid",
                                borderColor: "grey.300",
                                borderRadius: 1,
                                p: 1,
                            }}
                        >
                            <TextField
                                fullWidth
                                name="password"
                                type={showPass ? "text" : "password"}
                                variant="standard"
                                value={state.password}
                                onChange={handleInputs}
                                placeholder="Type your password"
                                InputProps={{ disableUnderline: true }}
                            />
                            <IconButton onClick={() => setShowPass(!showPass)}>
                                {showPass ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                        </Box>
                    </Box>

                    <Box mt={4}>
                        <Button
                            fullWidth
                            onClick={handleLogin}

                            sx={{
                                backgroundColor: colors.primaryLight,
                                color: 'white',
                                fontFamily: 'PSBo',
                                fontSize: 17,
                                textTransform: 'capitalize'
                                // "&:hover": { backgroundColor: "darkcyan" },
                            }}
                            // onClick={() => !loading && loginButton()}
                            disabled={isLoading}
                        >
                            {isLoading ? (
                                <CircularProgress size={24} color="inherit" />
                            ) : (
                                "Sign in"
                            )}
                        </Button>
                    </Box>
                </Box>

                {/* Additional Content Area */}
                <Box
                    flex={1}
                    display={{ xs: "none", md: "flex" }}
                    justifyContent="center"
                    alignItems="center"
                    sx={{
                        position: "relative",
                        overflow: "hidden",
                    }}
                >
                    {/* Replace with your image or content */}
                    <Typography variant="h4" color="white" textAlign="center"></Typography>
                </Box>
            </Box>
        </Box>
    );
};

export default Login;


// import React, { useState } from "react";
// import {
//     Box,
//     TextField,
//     Button,
//     Typography,
//     Link,
//     useMediaQuery,
//     CircularProgress,
// } from "@mui/material";
// import { Images } from "../../assets/images";
// import colors from "../../styles/colors";
// import { useTheme } from "@mui/material/styles";
// import { toast } from "react-toastify";
// import { useSignInMutation } from "../../store/services/userService"; // Import the sign-in API
// import { setSession } from "../../utils/session";
// import { useNavigate } from "react-router-dom";

// const SignIn = () => {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.between("xs", "md"));
//     const navigate = useNavigate();

//     // State for email and password
//     const [email, setEmail] = useState("");
//     const [password, setPassword] = useState("");
//     const [signIn, { isLoading }] = useSignInMutation(); // API hook

//     const labelStyle = {
//         fontFamily: "PMe",
//         fontSize: 14,
//         color: colors.text,
//         mb: 0.5,
//     };

//     const handleLogin = async (e) => {
//         e.preventDefault();

//         if (!email || !password) {
//             toast.error("Please fill in all fields.");
//             return;
//         }

//         try {
//             const response = await signIn({ email, password }).unwrap();
//             if (response.status === "1") {
//                 toast.success("Login successful!");
//                 setSession({
//                     token: response.token,
//                     user: response.user,
//                 });
//                 navigate("/dashboard/home"); // Redirect to dashboard
//             } else {
//                 toast.error("Invalid email or password.");
//             }
//         } catch (error) {
//             console.error("Sign-in error:", error);
//             toast.error(error.data?.error ?? "Something went wrong. Please try again.");
//         }
//     };

//     const FormDiv = () => {
//         return (
//             <Box
//                 sx={{
//                     minWidth: isMobile ? 400 : "75%",
//                     padding: 3,
//                     borderRadius: 2,
//                     borderTopLeftRadius: 0,
//                     borderBottomLeftRadius: 0,
//                     backgroundColor: "white",
//                 }}
//             >
//                 {/* Top Logo */}
//                 <Box sx={{ textAlign: "center", mb: 2 }}>
//                     <img
//                         src={Images.mrLogo}
//                         alt="Logo"
//                         style={{ maxWidth: "150px", height: "auto" }}
//                     />
//                 </Box>

//                 {/* Form Fields */}
//                 <Box sx={{ flex: 1, mb: 2 }}>
//                     <Typography sx={labelStyle}>Email*</Typography>
//                     <TextField
//                         fullWidth
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                     />
//                 </Box>
//                 <Box sx={{ flex: 1, mb: 2 }}>
//                     <Typography sx={labelStyle}>Password*</Typography>
//                     <TextField
//                         fullWidth
//                         type="password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                     />
//                 </Box>

//                 <Button
//                     fullWidth
//                     variant="contained"
//                     onClick={handleLogin}
//                     sx={{
//                         backgroundColor: colors.primary,
//                         fontFamily: "PRe",
//                         color: "white",
//                         mt: 2,
//                         "&:hover": {
//                             backgroundColor: "darkgreen",
//                         },
//                     }}
//                     disabled={isLoading} // Disable button while loading
//                 >
//                     {isLoading ? <CircularProgress size={24} color="inherit" /> : "Log In"}
//                 </Button>

//                 <Box sx={{ mt: 2, textAlign: "center" }}>
//                     <Link
//                         href="#"
//                         sx={{
//                             fontFamily: "Poppins-Medium",
//                             color: "green",
//                             textDecoration: "none",
//                             fontFamily: "PRe",
//                         }}
//                     >
//                         Forgot your password?
//                     </Link>
//                 </Box>
//             </Box>
//         );
//     };

//     return (
//         <Box
//             fullWidth
//             container
//             style={{
//                 backgroundImage: `url(${Images.signinbg})`,
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//                 height: "100vh",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//             }}
//         >
//             <Box
//                 sx={{ display: "flex", height: "60%", alignSelf: "center", marginLeft: -10 }}
//             >
//                 {!isMobile && (
//                     <img
//                         src={Images.markabat}
//                         alt="Markabat Logo"
//                         style={{ minWidth: "75%" }}
//                     />
//                 )}
//                 <Box
//                     sx={{
//                         minWidth: isMobile ? 400 : "75%",
//                         padding: 3,
//                         borderRadius: 2,
//                         borderTopLeftRadius: 0,
//                         borderBottomLeftRadius: 0,
//                         backgroundColor: "white",
//                     }}
//                 >
//                     {/* Top Logo */}
//                     <Box sx={{ textAlign: "center", mb: 2 }}>
//                         <img
//                             src={Images.mrLogo}
//                             alt="Logo"
//                             style={{ maxWidth: "150px", height: "auto" }}
//                         />
//                     </Box>

//                     {/* Form Fields */}
//                     <Box sx={{ flex: 1, mb: 2 }}>
//                         <Typography sx={labelStyle}>Email*</Typography>
//                         <TextField
//                             fullWidth
//                             value={email}
//                             onChange={(e) => setEmail(e.target.value)}
//                         />
//                     </Box>
//                     <Box sx={{ flex: 1, mb: 2 }}>
//                         <Typography sx={labelStyle}>Password*</Typography>
//                         <TextField
//                             fullWidth
//                             type="password"
//                             value={password}
//                             onChange={(e) => setPassword(e.target.value)}
//                         />
//                     </Box>

//                     <Button
//                         fullWidth
//                         variant="contained"
//                         onClick={handleLogin}
//                         sx={{
//                             backgroundColor: colors.primary,
//                             fontFamily: "PRe",
//                             color: "white",
//                             mt: 2,
//                             "&:hover": {
//                                 backgroundColor: "darkgreen",
//                             },
//                         }}
//                         disabled={isLoading} // Disable button while loading
//                     >
//                         {isLoading ? <CircularProgress size={24} color="inherit" /> : "Log In"}
//                     </Button>

//                     <Box sx={{ mt: 2, textAlign: "center" }}>
//                         <Link
//                             href="#"
//                             sx={{
//                                 fontFamily: "Poppins-Medium",
//                                 color: "green",
//                                 textDecoration: "none",
//                                 fontFamily: "PRe",
//                             }}
//                         >
//                             Forgot your password?
//                         </Link>
//                     </Box>
//                 </Box>
//             </Box>
//         </Box>
//     );
// };

// export default SignIn;
